<div class="container-fluid pb-5" *ngIf="showOldPrescriptions">
    <div class="w-100 h-100 d-flex align-items-center justify-content-center loader" *ngIf="progress_spinner">
        <span class="purpleLoader"></span>
    </div>

    <div *ngIf="!progress_spinner">
        <div class="d-flex align-items-center justify-content-between mb-2">
            <h4 class="main-heading">Prescription Drug Detail</h4>
            <button class="btn" mat-icon-button (click)="dialogRef.close()" type="button">
                <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
            </button>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card shadow-sm">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="acute">
                                    <div class="acute-content">
                                        <ng-container *ngIf="drugList && drugList.length > 0; else noData">
                                            <div class="pagination-table">
                                                <table class="table table-striped p-dash" aria-describedby="Drug table">
                                                    <thead>
                                                        <tr>
                                                            <th>Rx Num</th>
                                                            <th>Drug Name</th>
                                                            <th>Dosage</th>
                                                            <th>Repeats</th>
                                                            <th>Quantity</th>
                                                            <th>Strength</th>
                                                            <th>Dosage Form</th>
                                                            <th>Instructions</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        <tr *ngFor="let item of drugList">
                                                            <!-- Rx Num -->
                                                            <td>
                                                                <span *ngIf="!item.editMode">{{ item.rxNum || '-'
                                                                    }}</span>
                                                                <input *ngIf="item.editMode" [(ngModel)]="item.rxNum"
                                                                    class="form-control form-control-sm" />
                                                            </td>

                                                            <!-- Drug Name -->
                                                            <td>
                                                                <span *ngIf="!item.editMode">{{ item.drugName || '-'
                                                                    }}</span>
                                                                <input *ngIf="item.editMode" [(ngModel)]="item.drugName"
                                                                    class="form-control form-control-sm" />
                                                            </td>

                                                            <!-- Dosage -->
                                                            <td>
                                                                <span *ngIf="!item.editMode">{{ item.dosage || '-'
                                                                    }}</span>
                                                                <input *ngIf="item.editMode" [(ngModel)]="item.dosage"
                                                                    class="form-control form-control-sm" />
                                                            </td>

                                                            <!-- Repeats -->
                                                            <td>
                                                                <span *ngIf="!item.editMode">{{ item.repeats || '-'
                                                                    }}</span>
                                                                <input *ngIf="item.editMode" [(ngModel)]="item.repeats"
                                                                    class="form-control form-control-sm" />
                                                            </td>

                                                            <!-- Quantity -->
                                                            <td>
                                                                <span *ngIf="!item.editMode">{{ item.quantity || '-'
                                                                    }}</span>
                                                                <input *ngIf="item.editMode" [(ngModel)]="item.quantity"
                                                                    class="form-control form-control-sm" />
                                                            </td>

                                                            <!-- Strength -->
                                                            <td>
                                                                <span *ngIf="!item.editMode">{{ item.strength || '-'
                                                                    }}</span>
                                                                <input *ngIf="item.editMode" [(ngModel)]="item.strength"
                                                                    class="form-control form-control-sm" />
                                                            </td>

                                                            <!-- Dosage Form -->
                                                            <td>
                                                                <span *ngIf="!item.editMode">{{ item.dosageForm || '-'
                                                                    }}</span>
                                                                <input *ngIf="item.editMode"
                                                                    [(ngModel)]="item.dosageForm"
                                                                    class="form-control form-control-sm" />
                                                            </td>

                                                            <!-- Instructions -->
                                                            <td>
                                                                <span *ngIf="!item.editMode">{{ item.instructions || '-'
                                                                    }}</span>
                                                                <input *ngIf="item.editMode"
                                                                    [(ngModel)]="item.instructions"
                                                                    class="form-control form-control-sm" />
                                                            </td>

                                                            <!-- Action -->
                                                            <td>
                                                                <!-- Edit Icon  -->
                                                                <mat-icon *ngIf="!item.editMode && !item.saving"
                                                                    style="cursor:pointer; color:#1976d2"
                                                                    (click)="enableRowEdit(item)">
                                                                    edit
                                                                </mat-icon>

                                                                <!-- Confirm & Cancel Icons  -->
                                                                <div *ngIf="item.editMode && !item.saving"
                                                                    class="d-flex gap-2">
                                                                    <mat-icon style="cursor:pointer; color:green"
                                                                        (click)="confirmRowEdit(item)">
                                                                        check_circle
                                                                    </mat-icon>
                                                                    <mat-icon style="cursor:pointer; color:red"
                                                                        (click)="cancelRowEdit(item)">
                                                                        cancel
                                                                    </mat-icon>
                                                                </div>

                                                                <!-- Loader Icon -->
                                                                <mat-icon *ngIf="item.saving" class="spin"
                                                                    style="color:#1976d2">autorenew</mat-icon>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </ng-container>
                                        <ng-template #noData>
                                            <div class="w-100 text-center p-5">
                                                <img src="assets/images/emptystate.png" alt="no data found icon"
                                                    class="mb-3" />
                                                <div class="bold">No Data Found</div>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- This is for message_id table -->
<div class="container-fluid pb-5" *ngIf="showNewPrescriptions">
    <div class="w-100 h-100 d-flex align-items-center justify-content-center loader" *ngIf="progress_spinner">
        <span class="purpleLoader"></span>
    </div>

    <div *ngIf="!progress_spinner">
        <div class="d-flex align-items-center justify-content-between mb-2">
            <h4 class="main-heading">Prescription Drug Detail</h4>
            <button class="btn" mat-icon-button (click)="dialogRef.close()" type="button">
                <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
            </button>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card shadow-sm">
                    <div class="card-body">
                        <ng-container *ngIf="drugList && drugList.length > 0; else noDataNew">
                            <div class="pagination-table">
                                <table class="table table-striped p-dash" aria-describedby="Drug table">
                                    <thead>
                                        <tr>
                                            <th>Rx Num</th>
                                            <th>Drug Name</th>
                                            <th>Dosage</th>
                                            <th>Repeats</th>
                                            <th>Quantity</th>
                                            <th>Strength</th>
                                            <th>Dosage Form</th>
                                            <th>Instructions</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr *ngFor="let item of drugList">
                                            <!-- Rx Num -->
                                            <td>
                                                <span *ngIf="!item.editMode">{{ item.rxNum || '-' }}</span>
                                                <input *ngIf="item.editMode" [(ngModel)]="item.rxNum"
                                                    class="form-control form-control-sm" />
                                            </td>

                                            <!-- Drug Name -->
                                            <td>
                                                <span *ngIf="!item.editMode">{{ item.drugName || '-' }}</span>
                                                <input *ngIf="item.editMode" [(ngModel)]="item.drugName"
                                                    class="form-control form-control-sm" />
                                            </td>

                                            <!-- Dosage -->
                                            <td>
                                                <span *ngIf="!item.editMode">{{ item.dosage || '-' }}</span>
                                                <input *ngIf="item.editMode" [(ngModel)]="item.dosage"
                                                    class="form-control form-control-sm" />
                                            </td>

                                            <!-- Repeats -->
                                            <td>
                                                <span *ngIf="!item.editMode">{{ item.repeats || '-' }}</span>
                                                <input *ngIf="item.editMode" [(ngModel)]="item.repeats"
                                                    class="form-control form-control-sm" />
                                            </td>

                                            <!-- Quantity -->
                                            <td>
                                                <span *ngIf="!item.editMode">{{ item.quantity || '-' }}</span>
                                                <input *ngIf="item.editMode" [(ngModel)]="item.quantity"
                                                    class="form-control form-control-sm" />
                                            </td>

                                            <!-- Strength -->
                                            <td>
                                                <span *ngIf="!item.editMode">{{ item.strength || '-' }}</span>
                                                <input *ngIf="item.editMode" [(ngModel)]="item.strength"
                                                    class="form-control form-control-sm" />
                                            </td>

                                            <!-- Dosage Form -->
                                            <td>
                                                <span *ngIf="!item.editMode">{{ item.dosageForm || '-' }}</span>
                                                <input *ngIf="item.editMode" [(ngModel)]="item.dosageForm"
                                                    class="form-control form-control-sm" />
                                            </td>

                                            <!-- Instructions -->
                                            <td>
                                                <span *ngIf="!item.editMode">{{ item.instructions || '-' }}</span>
                                                <input *ngIf="item.editMode" [(ngModel)]="item.instructions"
                                                    class="form-control form-control-sm" />
                                            </td>

                                            <!-- Action -->
                                            <td>
                                                <!-- Edit Icon  -->
                                                <mat-icon *ngIf="!item.editMode && !item.saving"
                                                    style="cursor:pointer; color:#1976d2"
                                                    (click)="enableRowEditNewPres(item)">
                                                    edit
                                                </mat-icon>

                                                <!-- Confirm & Cancel Icons  -->
                                                <div *ngIf="item.editMode && !item.saving" class="d-flex gap-2">
                                                    <mat-icon style="cursor:pointer; color:green"
                                                        (click)="confirmRowEditNewPres(item)">
                                                        check_circle
                                                    </mat-icon>
                                                    <mat-icon style="cursor:pointer; color:red"
                                                        (click)="cancelRowEditNewPres(item)">
                                                        cancel
                                                    </mat-icon>
                                                </div>

                                                <!-- Loader Icon  -->
                                                <mat-icon *ngIf="item.saving" class="spin" style="color:#1976d2">
                                                    autorenew
                                                </mat-icon>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </ng-container>
                        <ng-template #noDataNew>
                            <div class="w-100 text-center p-5">
                                <img src="assets/images/emptystate.png" alt="no data found icon" class="mb-3" />
                                <div class="bold">No Data Found</div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- This is for slh prescription table -->
<div class="container-fluid pb-5" *ngIf="slhPrescription">
    <div class="w-100 h-100 d-flex align-items-center justify-content-center loader" *ngIf="progress_spinner">
        <span class="purpleLoader"></span>
    </div>

    <div *ngIf="!progress_spinner">
        <div class="d-flex align-items-center justify-content-between mb-2">
            <h4 class="main-heading">Prescription Drug Detail</h4>
            <button class="btn" mat-icon-button (click)="dialogRef.close()" type="button">
                <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
            </button>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card shadow-sm">
                    <div class="card-body">
                        <ng-container *ngIf="drugList && drugList.length > 0; else noDataNew">
                            <div class="pagination-table">
                                <table class="table table-striped p-dash" aria-describedby="Drug table">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Medication</th>
                                            <th>Dosage Instructions</th>
                                            <th>Quantity</th>
                                            <th>Repeats at</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr *ngFor="let item of drugList; let i = index">
                                            <td>{{ i + 1}}</td>
                                            <td>{{item?.medication || 'N/A'}} {{item?.drug_strength ? '(' +
                                                item?.drug_strength + ')' :
                                                '' }}</td>
                                            <td>{{item?.dosage_instructions || 'N/A'}}</td>
                                            <td>{{item?.quantity || 'N/A'}}</td>
                                            <td>{{item?.Repeats || 'N/A'}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </ng-container>
                        <ng-template #noDataNew>
                            <div class="w-100 text-center p-5">
                                <img src="assets/images/emptystate.png" alt="no data found icon" class="mb-3" />
                                <div class="bold">No Data Found</div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
